<template>
  <div v-loading="loading">
    <h5>Ultimas Observaciones</h5>
    <!-- <el-card shadow="never" class="report-observation" v-show="loading" v-loading="loading">
    </el-card> -->
    <el-card shadow="never" class="report-observation" 
      :key="reportId + '-' + observation.id" 
      v-for="observation in observations"> 
      <p class="comment revision">Revisión: {{ observation.revision_count }}</p>
      <p class="comment">
      {{ observation.observation }}
      </p>
      <el-row class="metadata">
        <el-col :sm="12">
          {{ observation.created_at }}
        </el-col>
        <el-col :sm="12" class="text-right text-primary">
          {{ observation.user.name }}
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { baseApi } from '../../../configs/urls'

export default {
  name: 'checkin-report-observations',
  props: ['reportId'],
  data () {
    return {
      loading: false,
      observations: []
    }
  },
  methods: {
    fetchObservations () {
      if (this.loading) {
        return
      }

      this.loading = true
      this.$http.get(baseApi + '/checkins-report/' + this.reportId + '/observations')
        .then(
          (res) => {
            this.loading = false
            this.observations = res.body
          },
          () => {
            this.loading = false
          }
        )
    }
  },
  mounted () {
    this.fetchObservations()
  }
}
</script>

<style lang="scss" scoped>
  .report-observation {
    max-width: 300px;
    .comment {
      margin: 0;
      font-size: 0.8rem;
      color: #5C656E;
      &.revision {
        color: black;
        font-size: 0.9rem;
        margin-bottom: 5px;
      }
    }
    .metadata {
      font-size: 0.9rem;
      margin-top: 0.5rem;
      .text-right {
      text-align: right;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/checkins/approval/CheckinReportObservations.vue